import styled from 'styled-components';

export const MobileAccountBoxTopUpButtonStyled = styled.button`
    position: relative;
    overflow: hidden;
    border: none !important;
    
    &.bonus-available {
        &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(115.61deg, rgba(255, 221, 60, 0.17) 0%, rgba(255, 221, 60, 0.0381225) 23.44%, rgba(255, 221, 60, 0) 50.6%, rgba(255, 221, 60, 0.0588748) 76.04%, rgba(255, 221, 60, 0.17) 100%);
        }
    }
`;

export const MobileAccountBoxTopUpButtonBonusLabelStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 8px;
    position: absolute;
    width: 130px;
    height: 24px;
    left: -46px;
    top: 8px;
    background: linear-gradient(95.67deg, #FFDD3C 36.96%, #FEFA7B 83.49%);
    transform: matrix(0.71, -0.71, 0.71, 0.71, 0, 0);
    color: var(--color-main);
    font-size: 12px;
    font-weight: 700;
`;

export const MobileAccountBoxTopUpButtonBonusPresentsContainerStyled = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    width: 35px;
    height: 26px;
    background-image: url(${`${process.env.PUBLIC_URL}/assets/bonus/bonus-welcome-gifts.svg`});
    
`;
